<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-format-list-checkbox"
    ></vuse-section-definition>

    <v-row class="mx-1 mt-3">
      <v-col class="mx-3" cols="3.5" sm="3.5">
        <v-text-field
            background-color="#EDF2F7"
            v-model="advice.name"
            filled
            label="Họ tên"
            @input="debounceInput"
        ></v-text-field>
      </v-col>
      <v-col class="mx-3" cols="3.5" sm="3.5">
        <v-text-field
            background-color="#EDF2F7"
            v-model="advice.phone"
            filled
            label='Số điện thoại'
            @input="debounceInput1"
        ></v-text-field>
      </v-col>
      <v-col class="mx-3" cols="3.5" sm="3.5">
        <v-select
            filled
            background-color="#EDF2F7"
            class="width-input"
            v-model="advice.status"
            :items="warranty_status"
            item-text="name"
            item-value="id"
            label="Trạng thái"
            @change="getItem"
            clearable
        ></v-select>
      </v-col>
      <v-col cols="3.5" align="right">
        <v-btn
            color="primary"
            align="right"
            @click="addNew"
            v-if="hasPermissions('Create advise')"
        >
          Thêm mới
        </v-btn>
      </v-col>
    </v-row>
    <v-container fluid>
      <v-row justify="center" align="center">

        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="adviceSearch"
              :items-per-page="10"
              class="elevation-1"
          >
            <template v-slot:item.status="{ item }">
              <span v-if="item.status == 2" class="warning--text">ĐANG TƯ VẤN</span>
              <span v-else-if="item.status == 3" class="primary--text">ĐÃ TƯ VẤN</span>
              <span v-else-if="item.status == 4">BỎ QUA</span>
              <span v-else class="red--text">CHƯA TƯ VẤN</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)" v-if="hasPermissions('Update advise')">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item)" v-if="hasPermissions('Delete advise')">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { GET_LIST_ADVISE, DELETE_ADVISE,GET_DATA_SEARCH_ADVISE} from "@/store/modules/advise";
import {mapGetters} from "vuex";
import {debounce} from "debounce";


export default {
  data() {
    return {
      page: "Yêu cầu tư vấn",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true
        },
        {
          text: "Yêu cầu tư vấn",
          disabled: true,
        },
        {
          text: "Danh sách yêu cầu tư vấn",
          disabled: true,
        },
      ],
      advice : {
        name: "",
        phone: "",
        status: null,
      },
      warranty_status: [
        {id:1, name:'CHƯA TƯ VẤN'},
        {id:2, name:'ĐANG TƯ VẤN'},
        {id:3, name:'ĐÃ TƯ VẤN'},
        {id:4, name:'BỎ QUA'},
      ],
      headers: [
        { text: 'ID', value: 'id' },
        {
          text: 'Họ tên',
          align: 'start',
          sortable: false,
          value: 'fullname',
        },
        { text: 'Ghi chú', value: 'note' },
        { text: 'Tên sản phẩm', value: 'name_product' },
        { text: 'SĐT', value: 'phone' },
        { text: 'Địa chỉ', value: 'address' },
        { text: 'Trạng thái', value: 'status' },
        { text: 'Actions', value: 'actions' },
      ],

    };
  },
  computed: {
    ...mapGetters({
      advices: "advices",
      adviceSearch: "dataSearchAdvices",
    }),
  },

  async created() {
    await this.$store.dispatch(GET_LIST_ADVISE);
    await this.$store.dispatch(GET_DATA_SEARCH_ADVISE);
  },
  methods:{
    debounceInput: debounce(function (e) {
      this.advice.name = e;
      let params = {
        name : this.advice.name,
        phone: this.advice.phone,
        status: this.advice.status
      };
      this.$store.dispatch(GET_DATA_SEARCH_ADVISE, params);

    }, 200),

    debounceInput1: debounce(function (e) {
      this.advice.phone = e;
      let params = {
        name : this.advice.name,
        phone: this.advice.phone,
        status: this.advice.status
      };
      this.$store.dispatch(GET_DATA_SEARCH_ADVISE, params);

    }, 200),
    getItem(){
      let params = {
        name : this.advice.name,
        phone: this.advice.phone,
        status: this.advice.status
      };
      this.$store.dispatch(GET_DATA_SEARCH_ADVISE ,params);

    },
    editItem(item){
      this.$router.push('/advise/detail_advise/'+ item.id)
    },
    deleteItem(item)
    {
      confirm('Bạn có chắc muốn xóa?') &&
      this.$store.dispatch(`${DELETE_ADVISE}`,item.id).then(data=>{
        if(data && data.status === 1) {
          this.$store.dispatch(GET_LIST_ADVISE);
        }
      })
    },
    addNew() {
      this.$router.push('/advise/add_advise')
    }
  }
};
</script>
<style scoped lang="scss">
.width-input {
  max-width: 240px!important;
}
</style>